export default __webpack_public_path__ + "static/media/Jntuk-white-logo.dcefb425.png";